import { create } from 'zustand';

const useFeedbackStore = create((set) => ({
  form: {
    name: '',
    phone: '',
    email: '',
    category: '',
    message: '',
  },
  errors: {
    name: false,
    phone: false,
    email: false,
    category: false,
    message: false,
  },
  setField: (field, value) =>
    set((state) => ({
      form: {
        ...state.form,
        [field]: value,
      },
    })),
  setError: (field, value) =>
    set((state) => ({
      errors: {
        ...state.errors,
        [field]: value,
      },
    })),
  resetForm: () =>
    set({
      form: {
        name: '',
        phone: '',
        email: '',
        category: '',
        message: '',
      },
      errors: {
        name: false,
        phone: false,
        email: false,
        category: false,
        message: false,
      },
    }),
}));

export default useFeedbackStore;